import { DialogPanel } from "@medoma/components/DialogPanel/DialogPanel";
import { useNavigate } from "react-router";
import { NewActivity } from "./NewActivity";
import { useLingui } from "@lingui/react/macro";

export const NewActivityDialog = ({
  redirectPathRelativeToCenterRootOnClose,
}: {
  // onClose navigation is required so that ESC, click outside, and close button all actually close the dialog
  // BUT, we can't control any navigation from within the dialog, so we need to pass the redirect path to this Dialog
  // which in this case is the relative path to the center root
  redirectPathRelativeToCenterRootOnClose: string;
}) => {
  const { t } = useLingui();
  const navigate = useNavigate();

  return (
    <DialogPanel
      isOpen={true}
      onClose={() => {
        void navigate(
          `/commandcenter/${redirectPathRelativeToCenterRootOnClose}`,
        );
      }}
      title={t`Skapa aktivitet`}
    >
      <NewActivity inDialog={true} />
    </DialogPanel>
  );
};
